"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DummyWindowInfoDTO_1 = require("../model/DummyWindowInfoDTO");

var DummyWindowConverter_1 = require("./DummyWindowConverter");

var DummyWindowInfoDTOConverter_1 = require("./DummyWindowInfoDTOConverter");

var DummyWindowInfoDTOConverterImpl =
/*#__PURE__*/
function (_DummyWindowInfoDTOCo) {
  _inherits(DummyWindowInfoDTOConverterImpl, _DummyWindowInfoDTOCo);

  function DummyWindowInfoDTOConverterImpl() {
    _classCallCheck(this, DummyWindowInfoDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowInfoDTOConverterImpl).apply(this, arguments));
  }

  _createClass(DummyWindowInfoDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new DummyWindowInfoDTO_1.DummyWindowInfoDTO(DummyWindowInfoDTO_1.DummyWindowInfoDTO.schema.isUsed.valueOfField(source), this.dummyWindowConverter.toObject(source.dummyWindow, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        isUsed: source.isUsed,
        dummyWindow: this.dummyWindowConverter.toDocument(source.dummyWindow, conversions)
      });
      return result;
    }
  }]);

  return DummyWindowInfoDTOConverterImpl;
}(DummyWindowInfoDTOConverter_1.DummyWindowInfoDTOConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", DummyWindowConverter_1.DummyWindowConverter)], DummyWindowInfoDTOConverterImpl.prototype, "dummyWindowConverter", void 0);

exports.DummyWindowInfoDTOConverterImpl = DummyWindowInfoDTOConverterImpl;